import { makeCareers } from 'src/main/factories/pages'

export default makeCareers
